export default {
  systemEmailList: [],
  manageSystemEmail: null
}
